const state= {};

const getters = {};

const actions = {
    async createItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/vendor-linking-creditor-code`, {
                method: "POST",
                data : params,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/vendor-linking-creditor-code/${params.id}`, {
                method: "PUT",
                data : params,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deteleItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`/api/vendor-linking-creditor-code`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/vendor-linking-creditor-code`, {params:params})
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    }
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}